import { FC } from "react";

import { Translate } from "@/app/application/Translate";
import { CloseActionButton } from "@/shared/ui";

interface CustomCloseButtonProps {
	handleClose: () => void;
	disabled?: boolean;
}

export const CustomCloseButton: FC<CustomCloseButtonProps> = (props) => {
	return (
		<CloseActionButton
			onClick={props.handleClose}
			disabled={props.disabled}
		>
			<Translate String="Training.Common.Button.Close">Close</Translate>
			{props.children}
		</CloseActionButton>
	);
};
